import makeStyles from "@mui/styles/makeStyles";
import { FontFamilySwitch } from "../../utils";

export const useStyles = makeStyles((theme) => ({
  name: {
    color: theme.typography.color.primary,
    fontSize: "0.75rem",
    fontFamily: FontFamilySwitch().bold,
  },
 }))